if ( typeof ProductImageZoom !== 'function' ) {
    class ProductImageZoom extends HTMLElement {

        constructor(){

            super();
            this.isTouchDevice =
              window.matchMedia('(max-width: 989px)').matches ||
              window.matchMedia('(pointer: coarse)').matches ||
              'ontouchstart' in window ||
              navigator.maxTouchPoints > 0;

            if (this.isTouchDevice) {
              return;
            }

            if ( ! document.getElementById('zoom') ) {
                this.zoom = document.createElement('div');
                this.zoom.id = 'zoom';
                this.zoom.innerHTML = `
                    <div class="zoom__backdrop"></div>
                    <div class="zoom__content">
                        <img class="zoom__img" />
                        <span class="zoom__loader">${KROWN.settings.symbols.zoom_loader}</span>
                    </div>
                    <button class="zoom__exit" aria-label="Chiudi">${KROWN.settings.symbols.zoom_out}</button>
                    <button class="zoom__prev" aria-label="Precedente">&#8592;</button>
                    <button class="zoom__next" aria-label="Successiva">&#8594;</button>
                `;
                document.body.append(this.zoom);

                this.zoom.querySelector('.zoom__exit').addEventListener('click', () => {
                    ProductImageZoom._unmount();
                });
                this.zoom.querySelector('.zoom__backdrop').addEventListener('click', () => {
                    ProductImageZoom._unmount();
                });
                this.zoom.querySelector('.zoom__prev').addEventListener('click', () => {
                    ProductImageZoom._navigate(-1);
                });
                this.zoom.querySelector('.zoom__next').addEventListener('click', () => {
                    ProductImageZoom._navigate(1);
                });
            }

            this.addEventListener('click', () => {
                ProductImageZoom._currentIndex = parseInt(this.getAttribute('data-index'));
                ProductImageZoom._open(this.getAttribute('data-image'));
            });

        }

    }

    // Metodi statici — accessibili da qualsiasi istanza e dai bottoni
    ProductImageZoom._open = function(src) {
        const zoom = document.getElementById('zoom');
        if (!zoom) return;
        zoom.classList.add('opened');
        zoom.classList.remove('loaded');
        const img = zoom.querySelector('.zoom__img');
        img.src = '';
        img.src = src;
        img.onload = () => { zoom.classList.add('loaded'); };

        const allZoomButtons = document.querySelectorAll('product-image-zoom');
        const hasMultiple = allZoomButtons.length > 1;
        zoom.querySelector('.zoom__prev').style.display = hasMultiple ? 'flex' : 'none';
        zoom.querySelector('.zoom__next').style.display = hasMultiple ? 'flex' : 'none';

        window.addEventListener('keydown', ProductImageZoom._onKeyDown);
    };

    ProductImageZoom._unmount = function() {
        const zoom = document.getElementById('zoom');
        if (!zoom) return;
        zoom.classList.remove('opened', 'loaded');
        window.removeEventListener('keydown', ProductImageZoom._onKeyDown);
        setTimeout(() => { zoom.querySelector('.zoom__img').src = ''; }, 300);
    };

    ProductImageZoom._navigate = function(direction) {
        const allZoomButtons = Array.from(document.querySelectorAll('product-image-zoom'));
        const total = allZoomButtons.length;
        if (total <= 1) return;
        ProductImageZoom._currentIndex = ((ProductImageZoom._currentIndex || 0) + direction + total) % total;
        const target = allZoomButtons.find(el => parseInt(el.getAttribute('data-index')) === ProductImageZoom._currentIndex);
        if (!target) return;
        ProductImageZoom._open(target.getAttribute('data-image'));
    };

    ProductImageZoom._onKeyDown = function(e) {
        if (e.key === 'Escape') ProductImageZoom._unmount();
        if (e.key === 'ArrowRight') ProductImageZoom._navigate(1);
        if (e.key === 'ArrowLeft') ProductImageZoom._navigate(-1);
    };

    ProductImageZoom._currentIndex = 0;

    if ( typeof customElements.get('product-image-zoom') == 'undefined' ) {
        customElements.define('product-image-zoom', ProductImageZoom);
    }

}
